import Axios from './Axios';

const API_URL = '/admin-settings/';

export const Setting = {
  getVersion: () => Axios.get(API_URL + 'getversion'),
  updateVersion: (payload) => Axios.post(API_URL + 'updateversion', payload),
};